'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgSearch(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M7.15384 11.2361C7.97659 11.2361 8.74582 10.9907 9.39466 10.5796L11.6087 12.7679C11.7692 12.9271 11.9766 13 12.1973 13C12.6589 13 13 12.6485 13 12.1976C13 11.9854 12.9264 11.7732 12.7726 11.6207L10.5786 9.43899C11.0334 8.77586 11.3077 7.9801 11.3077 7.11804C11.3077 4.85014 9.44147 3 7.15384 3C4.86622 3 3 4.85014 3 7.11804C3 9.37931 4.86622 11.2361 7.15384 11.2361ZM7.14285 10C5.57853 10 4.28571 8.71218 4.28571 7.14609C4.28571 5.57353 5.57853 4.28571 7.14285 4.28571C8.70717 4.28571 10 5.57353 10 7.14609C10 8.71218 8.70717 10 7.14285 10Z", fill: "currentColor" })));
}

module.exports = SvgSearch;
//# sourceMappingURL=Search.js.map
